module.exports = __webpack_public_path__ + "img/icon_share_border.982a9726.svg";